import { jwtDecode } from "jwt-decode";
import api from "./api";
import store from "../store";
import { setAccessToken, clearAccessToken } from "../slice/authSlice";
import { clearUser } from "../slice/userDetailsSlice";

const isTokenExpired = (token) => {
  if (!token) return true;
  try {
    const decoded = jwtDecode(token);
    const exp = decoded.exp || decoded.expires;
    if (!exp) return true;
    const now = Date.now() / 1000;
    return exp < now;
  } catch {
    return true;
  }
};

// ✅ LOGIN — returns tokens, caller stores them
export const login = async (email, password) => {
  const response = await api.post("app/signin", {
    email,
    password,
  });

  const data = response.data || {};
  const access = data?.data.access_token || null;
  const refresh = data?.data.refresh_token || null;

  if (access) {
    store.dispatch(setAccessToken(access));
  }
  if (refresh) {
    localStorage.setItem("refreshToken", refresh);
  }

  return data;
};

export const silentRefresh = async () => {
  try {
    const refreshToken = localStorage.getItem("refreshToken");
    const accessToken = store.getState()?.auth?.accessToken;

    if (!refreshToken) {
      return false;
    }
    if (accessToken && !isTokenExpired(accessToken)) {
      return true;
    }
    const response = await api.post(
      `${process.env.REACT_APP_API_BASE_URL}/app/refresh?token=${refreshToken}`
    );

    const newAccessToken = response.data?.access_token;
    if (newAccessToken) {
      store.dispatch(setAccessToken(newAccessToken));
      return true;
    }

    return false;
  } catch (err) {
    // Only clear token if refresh is really invalid
    if (err.response?.status === 401) {
      localStorage.removeItem("refreshToken");
    } else {
      console.warn(err.message);
    }
    return false;
  }
};

// ✅ LOGOUT
export const logout = () => {
  store.dispatch(clearAccessToken());
  localStorage.removeItem("refreshToken");
  store.dispatch(clearUser());
};
